import type React from "react";

import {faBars} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import CustomButton from "~/component/common/CustomButton";

import useModal from "../../../../hooks/useModal";
import EditMenuContent from "./EditMenuContent";

const EditMenuModalButton: React.FC = () => {
  const {openModal, closeModal, Modal} = useModal();

  return (
    <>
      <CustomButton
        onClick={openModal}
        aria-label="Open edit menu"
        className="p-2 rounded-full hover:bg-black hover:bg-opacity-70 transition-colors"
      >
        <FontAwesomeIcon
          icon={faBars}
          size="xl"
          className="text-white p-2 -m-2 rounded-full pl-2.5 pr-2.5 bg-gradient-to-br from-blue-600 via-blue-500 to-black"
        />
      </CustomButton>
      <Modal>
        <EditMenuContent closeModal={closeModal} />
      </Modal>
    </>
  );
};

export default EditMenuModalButton;
